<template lang="pug">
  .withdrawal-page
    .withdrawal
      h2.h2 Вывод денежных средств
      .withdrawal__content
        template(v-if="visibleItems > 0")
          p.no-result Нет подходящих вариантов
        .withdrawal-table(v-else)
          .withdrawal-table__title
            .withdrawal-table__th.at-col-1 id
            .withdrawal-table__th.at-col-2 Название
            .withdrawal-table__th.at-col-3 Баланс
            .withdrawal-table__th.at-col-4 Вывод

          .withdrawal-table__content
            template(v-if="windowWidth > 992")
              .withdrawal-table__item.item-draw(
                v-for='draw in withdrawal'
                :key="draw.id"
                v-if="draw.visible"
              )
                .item-draw__item.at-col-1 {{ draw.id }}
                .item-draw__item.at-col-2
                  .item-draw__title {{ draw.name }}
                .item-draw__item.at-col-3
                  .item-draw__balance {{ onFormat(draw.balance) }} Р
                .item-draw__item.at-col-4
                  template(v-if="draw.id === 132789")
                    router-link(to="/withdrawal-inner1").btn.btn--dark-grey Запросить вывод
                  template(v-else)
                    router-link(to="/withdrawal-inner").btn.btn--dark-grey Запросить вывод
            template(v-else)
              .withdrawal-table__item.item-draw(
                v-for='draw in withdrawal'
                :key="draw.id"
                v-if="draw.visible"
              )
                .item-draw__item.at-col-1
                  span id
                  |{{ draw.id }}
                .item-draw__item.at-col-2
                  .item-draw__title
                    span Название
                    |{{ draw.name }}
                .item-draw__item.at-col-3
                  .item-draw__balance
                    span Баланс
                    |{{ onFormat(draw.balance) }} Р
                .item-draw__item.at-col-4
                  span Вывод
                  a(href='#').btn.btn--dark-grey Запросить вывод
    .increase-sales
      h2.h2.increase-sales__title Как увеличить продажи?
      .increase-sales__content
        a(href='#').increase-sales__item
          span Запуститe e-mail рассылку
          svgicon(name='email')
        a(href='#').increase-sales__item
          span Закажите рассылку SMS
          svgicon(name='sms')
        a(href='#').increase-sales__item
          span Рассчитайте продвижение
          svgicon(name='cash')
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: 'Withdrawal',
  data: function() {
    return {
      windowWidth: null,
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.resize);
      this.resize()
    })
  },
  computed: {
    ...mapGetters([
      'withdrawal',
    ]),
    visibleItems(){
      let visibleItems = 0;
      this.withdrawal.forEach(item => {
        if(item.visible == false) {
          visibleItems += 1;
        }
      });
      return this.withdrawal.length == visibleItems;
    },
  },
  methods: {
    onFormat(number) {
      return parseFloat(number).toLocaleString('ru-RU')
    },
    resize() {
      this.windowWidth = document.documentElement.clientWidth;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  }
}
</script>

<style lang='scss' scoped>
  .withdrawal-table__th,
  .item-draw__item{
    padding-right: 10px;
  }
  .at-col-1{
    width: 100px;
    flex-grow: 0;
  }
  .at-col-2{
    width: 450px;
    margin-right: auto;
  }
  .at-col-3{
    width: 250px;
  }
  .at-col-4{
    width: 170px;
    flex-shrink: 0;
  }
</style>
<style lang='scss'>
.withdrawal{
  margin: 40px;
}

.withdrawal-table{
  width: 100%;
  &__title{
    display: flex;
    margin-bottom: 10px;
    padding: 0px 25px;
  }
  &__th{
    color: #9398a2;
    font-size: 14px;
  }
  &__content{
    box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
  }
}
.item-draw{
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 15px 25px;
  color: #161616;
  font-size: 14px;
  position: relative;
  &:before{
    content: '';
    display: block;
    position: absolute;
    top: -1px;
    left: 25px;
    width: calc(100% - 50px);
    height: 1px;
    background: #e4e4e4;
  }
  &:hover{
    background-color: #e7f1f8;
  }
  &:first-child:before{
    display: none;
  }
  &__title,
  &__balance{
    font-size: 16px;
    font-weight: 600;
  }
  &__item{
    span{
      font-size: 12px;
      display: block;
      margin-bottom: 8px;
      color: #a2a2a2;
    }
  }
}
.increase-sales{
  margin: 40px 40px 20px;
  &__content{
    display: flex;
  }
  &__item{
    border: 1px solid #e4e4e4;
    background-color: #fff;
    text-decoration: none;
    padding: 15px 20px 15px 30px;
    display: flex;
    align-items: center;
    color: #161616;
    font-size: 16px;
    font-weight: 700;
    margin-right: 20px;
    .svg-icon{
      color: #008cff;
      display: block;
      margin-left: 15px;
      height: 28px;
      width: 28px;
      flex-shrink: 0;
    }
    &:hover{
      box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
    }
  }
}

@media (max-width: 991px) {
  .withdrawal {
    margin: 20px;
  }
  .item-draw{
    flex-wrap: wrap;
    &__item{
      flex-grow: 0;
      margin-top: 10px;
      margin-bottom: 10px;
      &.at-col-2{
        width: calc(100% - 300px);
      }
      &.at-col-3{
        width: 150px;
      }
      &.at-col-4{
        width: 100%;
        text-align: center;
      }
    }
  }
  .withdrawal-table__title{
    display: none;
  }
}
@media (max-width: 767px)  {
  .increase-sales{
    margin: 20px 20px;
  }
  .increase-sales__content{
    flex-direction: column;
  }
  .increase-sales__item{
    margin-right: 0;
    margin-bottom: 20px;
    justify-content: center;
  }
  .item-draw {
    flex-wrap: wrap;
    justify-content: space-between;
    &__item {
      width: calc(50% - 10px);
      &.at-col-2{
        order: -1;
        width: 100%;
      }
    }
  }
}
@media (max-width: 479px)  {
  .increase-sales__item{
    font-size: 14px;
    padding: 15px;
    justify-content: space-between;
  }
}
</style>